const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
})

const usd2Formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const numFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0,
})

export function formatUSD(value: number): string {
  return usdFormatter.format(value)
}

export function formatUSD2(value: number): string {
  return usd2Formatter.format(value)
}

export function formatNumber(value: number): string {
  return numFormatter.format(value)
}

export function formatHours(value: number): string {
  if (!isFinite(value) || isNaN(value)) return "—"
  return value.toLocaleString("en-US", { minimumFractionDigits: 1, maximumFractionDigits: 1 })
}
